import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { CLAIM_GAIN_NUDGE } from "@constants/analytics";
import { useVaultTvlApy } from "@hooks/useVaultTvlApy";
import { Button, Typography } from "@kelp-dao/kernel-design-system";
import { getUrlForLocalImage, trackEvent } from "utils";

type TGainOpportunitiesCard = {
  title: string;
  logo: string;
  apy: string;
};

const GainNudge = () => {
  const { formattedApy = "-" } = useVaultTvlApy("agETH");
  const { formattedApy: yieldApy = "-" } = useVaultTvlApy("hgETH");

  const renderDesktopView = () => {
    return (
      <div
        className="bg-subbrand-background p-4 rounded-xl h-full lg:h-[92px] xl:h-[58px]"
        style={{
          backgroundImage: `url(${getUrlForLocalImage(
            "/assets/gain-nudge-new.png",
          )})`,
          backgroundRepeat: "no-repeat",
          backgroundPositionX: "right",
          backgroundPositionY: "bottom",
          backgroundSize: "200px",
        }}
      >
        <div className="flex flex-col xl:flex-row items-start xl:items-center justify-between xl:justify-start gap-4 lg:gap-0 xl:gap-4 max-w-[600px] h-full">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
            <GainItem
              title="Airdrop Gain"
              logo="/assets/agETH.png"
              apy={formattedApy}
            />
            <div className="border-r border-border-default h-10 hidden xl:block"></div>
            <GainItem
              title="High Gain"
              logo="/assets/vaults/hgeth.svg"
              apy={yieldApy}
            />
          </div>
          <EarnRewardsBtn />
        </div>
      </div>
    );
  };

  return <div className="">{renderDesktopView()}</div>;
};

const GainItem = ({ title, logo, apy }: TGainOpportunitiesCard) => {
  return (
    <div className="flex items-center justify-start gap-[6px]">
      <BaseImage src={logo} width={20} height={20} alt={""} />
      <Typography type="body" variant="small" className="text-text-primary">
        {title} {`(upto ${apy} APY)`}
      </Typography>
    </div>
  );
};

export default GainNudge;

const EarnRewardsBtn = () => {
  return (
    <UTMLink
      href={"https://gain.kerneldao.com/vaults/"}
      onClick={() => trackEvent(CLAIM_GAIN_NUDGE)}
    >
      <Button
        variant="outline"
        size="small"
        className="text-button-secondary-text text-xs font-normal leading-4 px-2 py-[6px] border rounded-[4px] border-solid border-border-default bg-white w-max"
      >
        Earn top rewards
      </Button>
    </UTMLink>
  );
};
